import { createSlice } from '@reduxjs/toolkit'
import { Operation } from 'models';
import { createInitialSlice } from 'store/utils';
import { createListAsyncThunk, GenericItemSelectorResult, GenericListSelectorResult, getStateItemMetas, getStateListEntities, getStateListMetas } from 'store/factory';
import { getOperationsAsync, ListByAgencyGroupArgs } from 'services/agency-groups';

// DEFINITION
const sliceConfiguration = {
  name: 'operations',
};
const initialState = createInitialSlice<Operation>();

// THUNKS
const fetchOperations = createListAsyncThunk<Operation, ListByAgencyGroupArgs>(getOperationsAsync, { ...sliceConfiguration, type: 'fetchOperations' });

export { fetchOperations };

// SLICE
const slice = createSlice({
  ...sliceConfiguration,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchOperations.addCasesTo?.(builder);
  },
});

export default slice.reducer;

// SELECTORS
export const getOperations = (state: any): GenericListSelectorResult<Operation> => {
  const { status, ids, meta, error } = getStateListMetas<Operation>(state, 'all', sliceConfiguration);
  const entities = getStateListEntities<Operation>(state, ids, sliceConfiguration);
  return [entities, { ...meta, status }, error];
};

export const getOperationIsActiveById = (operationId: string) => (state: any): GenericItemSelectorResult<boolean> => {
  const { status, error,  meta, data = {} as Operation } = getStateItemMetas<Operation>(state, operationId, sliceConfiguration);
  return [data.active, { ...meta, status }, error];
};